/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Current_PeriodInputs */

const en_settings_billing_current_period = /** @type {(inputs: Settings_Billing_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current period`)
};

const zh_settings_billing_current_period = /** @type {(inputs: Settings_Billing_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前周期`)
};

/**
* | output |
* | --- |
* | "Current period" |
*
* @param {Settings_Billing_Current_PeriodInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_current_period = /** @type {((inputs?: Settings_Billing_Current_PeriodInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Current_PeriodInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_current_period(inputs)
	return zh_settings_billing_current_period(inputs)
});
export { settings_billing_current_period as "settings.billing.current_period" }